import { Card, CardBody, Col } from "reactstrap";
import { fileUploadData } from "../../../../Data/BonusUiData/DropzoneData";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonFileUpload from "../../../../Utils/CommonComponents/CommonFileUpload";
import { MultiFileUploadTitle } from "../../../../Utils/Constants";

export default function MultiFileUpload() {
  return (
    <Col lg={6}>
      <Card>
        <CommonCardHeader title={MultiFileUploadTitle} subTitle={fileUploadData} />
        <CardBody className="custom-dropzone">
          <CommonFileUpload multiple />
        </CardBody>
      </Card>
    </Col>
  );
}
